import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "absolute -top-2 -right-2 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-[10px] text-white font-bold animate-pulse"
}
const _hoisted_3 = {
  key: 0,
  class: "absolute top-full right-0 mt-2 w-80 bg-white dark:bg-black rounded-lg shadow-xl border border-gray-200 dark:border-gray-700 overflow-hidden z-50"
}
const _hoisted_4 = { class: "px-4 py-3 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-black" }
const _hoisted_5 = { class: "flex items-center justify-between" }
const _hoisted_6 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_7 = { class: "divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_8 = { class: "flex items-center space-x-2" }
const _hoisted_9 = { class: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400" }
const _hoisted_10 = { class: "flex items-center space-x-2" }
const _hoisted_11 = { class: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400" }
const _hoisted_12 = {
  key: 0,
  class: "px-4 py-8 text-center"
}

import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { useNotificationStore } from '@/stores/notificationStore';
import { useBrand } from '@/composables/brand/useBrand';
import { useClickOutside } from '@/composables/ui/useClickOutside';


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationDropdown',
  setup(__props) {

const router = useRouter();
const notificationStore = useNotificationStore();
const { brandColors } = useBrand();

// State
const isOpen = ref(false);
const dropdownRef = ref<HTMLElement | null>(null);

// Computed
const totalCount = computed(() => notificationStore.totalCount);
const pendingClaimsCount = computed(() => notificationStore.pendingClaimsCount);
const pendingTiresCount = computed(() => notificationStore.pendingTiresCount);

// Methods
function toggleDropdown() {
  isOpen.value = !isOpen.value;
}

function goToPendingClaims() {
  router.push({
    name: 'admin-claims',
    query: { status: 'under review' }
  });
  isOpen.value = false;
}

function goToPendingTires() {
  router.push({
    name: 'admin-tire-approvals',
    query: { status: 'pending' }
  });
  isOpen.value = false;
}

// Click outside to close
const { handleClickOutside } = useClickOutside(isOpen);

// Lifecycle
onMounted(() => {
  notificationStore.startAutoRefresh();
  document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
  notificationStore.stopAutoRefresh();
  document.removeEventListener('click', handleClickOutside);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "relative",
    ref_key: "dropdownRef",
    ref: dropdownRef
  }, [
    _createElementVNode("button", {
      onClick: toggleDropdown,
      class: "flex items-center justify-center hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full p-2 transition-all duration-300 transform hover:scale-110",
      style: _normalizeStyle({ color: _unref(brandColors).primary })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24",
          fill: "currentColor",
          class: "w-6 h-6"
        }, [
          _createElementVNode("path", {
            "fill-rule": "evenodd",
            d: "M5.25 9a6.75 6.75 0 0 1 13.5 0v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 0 1-.297 1.206c-1.544.57-3.16.99-4.831 1.243a3.75 3.75 0 1 1-7.48 0 24.585 24.585 0 0 1-4.831-1.244.75.75 0 0 1-.298-1.205A8.217 8.217 0 0 0 5.25 9.75V9Zm4.502 8.9a2.25 2.25 0 1 0 4.496 0 25.057 25.057 0 0 1-4.496 0Z",
            "clip-rule": "evenodd"
          })
        ], -1)),
        (totalCount.value > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(totalCount.value > 9 ? '9+' : totalCount.value), 1))
          : _createCommentVNode("", true)
      ])
    ], 4),
    _createVNode(_Transition, { name: "dropdown" }, {
      default: _withCtx(() => [
        (isOpen.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "text-sm font-semibold text-gray-900 dark:text-white" }, " Notifications ", -1)),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(totalCount.value) + " pending ", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  onClick: goToPendingClaims,
                  class: "w-full px-4 py-3 flex items-center justify-between hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150 text-left group"
                }, [
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex items-center space-x-3" }, [
                    _createElementVNode("div", { class: "flex-shrink-0 w-10 h-10 rounded-full bg-yellow-100 dark:bg-yellow-900/30 flex items-center justify-center" }, [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "h-5 w-5 text-yellow-600 dark:text-yellow-400",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                        })
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", { class: "text-sm font-medium text-gray-900 dark:text-white" }, " Pending Claims "),
                      _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400" }, " Claims awaiting review ")
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(pendingClaimsCount.value), 1),
                    _cache[2] || (_cache[2] = _createElementVNode("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      class: "h-4 w-4 text-gray-400 group-hover:text-gray-600 dark:group-hover:text-gray-300 transition-colors",
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M9 5l7 7-7 7"
                      })
                    ], -1))
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: goToPendingTires,
                  class: "w-full px-4 py-3 flex items-center justify-between hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150 text-left group"
                }, [
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex items-center space-x-3" }, [
                    _createElementVNode("div", { class: "flex-shrink-0 w-10 h-10 rounded-full bg-orange-100 dark:bg-orange-900/30 flex items-center justify-center" }, [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "h-5 w-5 text-orange-600 dark:text-orange-400",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        }),
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M9 12a3 3 0 106 0 3 3 0 00-6 0z"
                        })
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", { class: "text-sm font-medium text-gray-900 dark:text-white" }, " Pending Tire Approvals "),
                      _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400" }, " Tire registrations awaiting review ")
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(pendingTiresCount.value), 1),
                    _cache[4] || (_cache[4] = _createElementVNode("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      class: "h-4 w-4 text-gray-400 group-hover:text-gray-600 dark:group-hover:text-gray-300 transition-colors",
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M9 5l7 7-7 7"
                      })
                    ], -1))
                  ])
                ])
              ]),
              (totalCount.value === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[6] || (_cache[6] = [
                    _createElementVNode("div", { class: "text-4xl mb-2" }, "🎉", -1),
                    _createElementVNode("p", { class: "text-sm text-gray-500 dark:text-gray-400" }, " No pending notifications ", -1)
                  ])))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 512))
}
}

})